// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import firebase from 'firebase';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCrosshairs,
  faCopy,
  faTrashAlt,
  faCaretRight,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router/router';
import store from './store/store';


library.add(faCrosshairs, faCopy, faTrashAlt, faCaretRight, faPlus);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyAvBAWsepSlGY4HKHNo3n5YqYPBfki8VoU',
  authDomain: 'hsl-picker.firebaseapp.com',
  databaseURL: 'https://hsl-picker.firebaseio.com',
  projectId: 'hsl-picker',
  storageBucket: '',
  messagingSenderId: '83886988036',
};

firebase.initializeApp(config);

/* eslint-disable no-new */
// Wrap the vue instance in a Firebase onAuthStateChanged method
// This stops the execution of the navigation guard 'beforeEach'
// method until the Firebase initialization ends
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    store.dispatch('setUser');
  }

  new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App),
  });
});
